import Text, { TEXT_TAG, TEXT_VARIANT } from '@pixum/text';
import Button from '@pixum/button';
import styles from './ForgotPasswordSuccess.module.css';

const NEWSLETTER_CHECK_IMAGE_URL = 'https://cdn.pixum.com/assets/area/mein-pixum/img/newsletter_check.svg';

interface ForgotPasswordSuccessProps {
  constants: Record<string, string>;
  onBackToLogin: () => void;
}

export function ForgotPasswordSuccess({ constants, onBackToLogin }: ForgotPasswordSuccessProps) {
  return (
    <div className={styles.container}>
      <img src={NEWSLETTER_CHECK_IMAGE_URL} alt="" aria-hidden="true" className={styles.image} />
      <Text tag={TEXT_TAG.H2} variant={TEXT_VARIANT.HEADLINE}>
        {constants['i18n_password_forgotten_success_title']}
      </Text>
      <Text tag={TEXT_TAG.P} variant={TEXT_VARIANT.BODY}>
        {constants['i18n_password_reset_link_sent']}
      </Text>
      <div className={styles.actions}>
        {/* Use a callback instead of href to avoid a full RSC navigation — flipping state
            keeps the user in the same render, eliminating the white-page flash on return. */}
        <Button onClick={onBackToLogin} variant="primary" size="medium">
          {constants['i18n_back_to_login']}
        </Button>
      </div>
    </div>
  );
}
